import React, { useState } from "react";
import { useRecoilState } from "recoil";
import { Grid, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  NewReqInsurancePadding,
  PatientBillingBox,
  PolicyOwnerRelationshipText,
  RadioFormControl,
  StyledFormLabel,
} from "./NewRequisition.styles";
import { currentNewRequisitionEdit } from "../../recoil/atoms";
import NewReqFileUploader, { FileUploadInfo } from "./NewReqFileUploader";
import { getRelationshipToInsured, getInsuredParameter } from "./helpers";

const NewReqBillToInsuranceUpload: React.FC = () => {
  const [isFileUploadProcessing, setFileUploadProcessing] = useState(false);
  const [newRequisition, setNewRequisition] = useRecoilState(
    currentNewRequisitionEdit,
  );
  const { requisitionForm } = newRequisition;
  return (
    <>
      <Grid item xs={3}>
        <FormControlLabel
          value="Upload"
          control={<Radio />}
          label={GetTypographyContent({
            content: "Upload a digital copy of insurance card",
            size: "medium",
            textColor: "greyMedium",
          })}
        />
      </Grid>
      {((newRequisition.preflight &&
        Object.keys(requisitionForm.insuranceFileUrls).length) ||
        !newRequisition.preflight) &&
        requisitionForm.billToInsuranceType === "Upload" && (
          <NewReqInsurancePadding>
            <div>
              <StyledFormLabel
                style={{ lineHeight: 2.5, textTransform: "none" }}
                error={
                  newRequisition.isError &&
                  requisitionForm.billToInsurance &&
                  !requisitionForm.relationshipToPolicyOwnerDependent &&
                  !requisitionForm.relationshipToPolicyOwnerSelf &&
                  !requisitionForm.relationshipToPolicyOwnerOther
                }
              >
                <PolicyOwnerRelationshipText>
                  {GetTypographyContent({
                    content: "Patient's Relationship to Policy Owner*",
                    size: "small",
                    textColor: "blueDark",
                  })}
                </PolicyOwnerRelationshipText>
              </StyledFormLabel>
              <PatientBillingBox>
                <RadioFormControl
                  $hideBorder
                  error={
                    newRequisition.isError &&
                    requisitionForm.billToInsurance &&
                    !requisitionForm.relationshipToPolicyOwnerDependent &&
                    !requisitionForm.relationshipToPolicyOwnerSelf &&
                    !requisitionForm.relationshipToPolicyOwnerOther
                  }
                >
                  <RadioGroup
                    value={getRelationshipToInsured(
                      requisitionForm.relationshipToPolicyOwnerSelf,
                      requisitionForm.relationshipToPolicyOwnerDependent,
                      requisitionForm.relationshipToPolicyOwnerOther,
                    )}
                    onChange={(e) =>
                      setNewRequisition({
                        ...newRequisition,
                        requisitionForm: {
                          ...newRequisition.requisitionForm,
                          relationshipToPolicyOwnerSelf: false,
                          relationshipToPolicyOwnerDependent: false,
                          relationshipToPolicyOwnerOther: false,
                          [getInsuredParameter(
                            e.target.value as "Self" | "Dependent" | "Other",
                          )]: true,
                        },
                      })
                    }
                    row
                  >
                    <Grid container spacing={2} />
                    <Grid item xs={3}>
                      <FormControlLabel
                        value="Self"
                        control={<Radio />}
                        label={GetTypographyContent({
                          content: "Self",
                          size: "medium",
                          textColor: "greyMedium",
                        })}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <FormControlLabel
                        value="Dependent"
                        control={<Radio />}
                        label={GetTypographyContent({
                          content: "Dependent",
                          size: "medium",
                          textColor: "greyMedium",
                        })}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <FormControlLabel
                        value="Other"
                        control={<Radio />}
                        label={GetTypographyContent({
                          content: "Other",
                          size: "medium",
                          textColor: "greyMedium",
                        })}
                      />
                    </Grid>
                  </RadioGroup>
                </RadioFormControl>
              </PatientBillingBox>
            </div>
            <Grid item xs={12}>
              <NewReqFileUploader
                type="insurance"
                insuranceType="primary"
                value={requisitionForm.insuranceFileUrls}
                setValue={(files: FileUploadInfo) => {
                  setNewRequisition({
                    ...newRequisition,
                    requisitionForm: {
                      ...newRequisition.requisitionForm,
                      insuranceFileUrls: files,
                    },
                  });
                }}
                uploadProcessing={isFileUploadProcessing}
                setUploadProcessing={setFileUploadProcessing}
                preflight={newRequisition.preflight}
              />
            </Grid>
          </NewReqInsurancePadding>
        )}
    </>
  );
};
export default NewReqBillToInsuranceUpload;
